import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const Wrapper = styled.div` 
    width: 100%;
    height: auto;
    padding: 32px;
    max-width: 1230px;

    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const PageBody = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    gap: 24px;

    @media (max-width: 767px) {
        flex-direction: column;
        gap: 0;
    }
`;

export const MainContent = styled.div`
    width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
`;

export const Content = styled.div`
    width: 100%;
    height: auto;
    padding-top: 8px;

    gap: 8.5px;
    display: flex;
    flex-direction: column;
`;

export const ContainerItemNotFound = styled.div`
    width: 100%;
    height: calc(100vh - 21.05rem);

    gap: 1rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
   
   >img{
    width: 100%;
    height: auto;
    max-width: 245px;
   }
`;

export const ContainerOthersContent  = styled.div`
    width: 100%;
    height: auto;
    padding-top: 24px;

    gap: 24px;
    display: flex;

    @media (max-width: 1100px) {
        flex-direction: column;
    }
`;

export const ContainerOthersContentFirst= styled.div`
    width: 100%;
    height: auto;
    max-width: 330px;

    @media (max-width: 1100px) {
         max-width: 100%;
    }
`;

export const LoadingContainer = styled.div`
    width: 100%;
    min-height: 18rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Loading = styled.div`

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 80px;
  height: 80px;
  position: relative;

  background-color: transparent;
  border-top: 1px solid #2fbb69;
  border-bottom: 1px solid #2fbb69;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;

`;
